(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["featured-product"] && !window.DesignMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  function debounce(func, timeout = 300){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach((item) =>
        item.addEventListener('click', this.onItemClick.bind(this))
      );
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target
        .closest('ul')
        .querySelector('.animation-underline--active')
        .classList.remove('animation-underline--active');
      event.target.classList.add('animation-underline--active');
      if (document.getElementById('SortBy')) {
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      } else {
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function () {
        _this.hidePanel();
      }, 150);
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  class stickyFilterModal extends HTMLElement {
    constructor() {
      super();
      this.mainButton = document.getElementById(`mobile-facets`);
      window.addEventListener('scroll', this.update.bind(this));
      this.querySelector('button').addEventListener('click', this.click.bind(this), false);
      this.update();
    }
    click(e) {
      e.preventDefault();
      document.body.setAttribute('data-top', window.pageYOffset);
      document.body.style.top = `-${window.pageYOffset}px`;
      document.body.classList.add(`fixed-position`);
      document.body.classList.add('overflow-hidden-tablet');
      this.mainButton.querySelector('[tabindex]').setAttribute('tabindex', '');
      this.mainButton.classList.add('menu-opening');
      this.mainButton.setAttribute('open', 'true');
    }
    update() {
      if (window.innerWidth > 992) return;
      const rangeToShowModal = this.getTop(this.mainButton) + this.mainButton.clientHeight;
      if (window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')) {
        this.classList.add('show-modal');
      }
      if (window.scrollY < rangeToShowModal && this.classList.contains('show-modal')) {
        if (document.body.classList.contains('fixed-position')) return;
        this.classList.remove('show-modal');
      }
    }
    getTop(el) {
      return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
    }
  }
  customElements.define('sticky-filter-modal', stickyFilterModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
    document.addEventListener("GlobalJSLoaded", function() {
      class ProductModal extends ModalDialog {
        constructor() {
          super();
        }

        hide() {
          super.hide();
        }

        show(opener) {
          super.show(opener);
          this.showActiveMedia();
        }

        showActiveMedia() {
          this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
              element.classList.remove('active');
            }
          )
          const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          activeMedia.scrollIntoView();

          const container = this.querySelector('[role="document"]');
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

          if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
            activeMedia.loadContent();
        }
      }

      if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);
    });


    // Basic MDV To Set Price / Quantity On Sticky Banners - This is Floating Point Arithmetic = Bad - Should Be Done In Proper Pricing Model
    (function BasicMDV() {
      document.addEventListener("DOMContentLoaded", function() {
        const body = document.querySelector('body');
        body.classList.add('mdv-loaded');

        const priceEls = Array.prototype.slice.call(document.querySelectorAll('[data-mdv-unit-price]'));
        if (!priceEls) return;

        const unit_price = parseFloat(priceEls[0]?.getAttribute('data-mdv-unit-price'));
        if (!unit_price) return;

        let quantity = 1;
        let price = unit_price.toFixed(2);

        var quantities = Array.prototype.slice.call(document.querySelectorAll('[data-mdv-quantity]'));
        var prices =  Array.prototype.slice.call(document.querySelectorAll('[data-mdv-price]'));

        for (let i = 0; i < quantities.length; i++) {
          quantities[i].addEventListener('change', function(event) {
            quantity = parseInt(event.target.value, 10);
            price = (quantity * unit_price).toFixed(2);
            updateMDVPricing();
          });
        }

        function updateMDVPricing() {
          let skio = document.querySelector('skio-plan-picker')
          let selectedSellingPlan = skio.selectedSellingPlan
          if (skio && selectedSellingPlan) {
            let discountAdjustment = (100 - selectedSellingPlan.price_adjustments[0].value) / 100
            for (let x = 0; x < quantities.length; x++) {
            quantities[x].value = quantity;
            }
            for (let y = 0; y < prices.length; y++) {
              prices[y].innerText = '£' + (price * discountAdjustment).toFixed(2);
            }
          }
          else {
            for (let x = 0; x < quantities.length; x++) {
            quantities[x].value = quantity;
            }
            for (let y = 0; y < prices.length; y++) {
              prices[y].innerText = '£' + price;
            }
          }

        }
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target.closest('ul').querySelector('.animation-underline--active').classList.remove("animation-underline--active");
      event.target.classList.add("animation-underline--active");
      document.getElementById('SortBy').value = event.target.dataset.value;
      document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function(){_this.hidePanel();}, 150)
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ux-product-grid"]) return;
  try {
    
  class SortByHandler extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('.disclosure__link').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.button.innerHTML = event.target.dataset.name;
      event.target
        .closest('ul')
        .querySelector('.animation-underline--active')
        .classList.remove('animation-underline--active');
      event.target.classList.add('animation-underline--active');
      if (document.getElementById('SortBy')) {
        document.getElementById('SortBy').value = event.target.dataset.value;
        document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
      } else {
        document.getElementById('SortBy-mobile').value = event.target.dataset.value;
        document.getElementById('FacetFiltersFormMobile').dispatchEvent(new Event('input'));
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      var _this = this;
      setTimeout(function() {
        _this.hidePanel();
      }, 150);
    }
  }

  customElements.define('sort-by-select', SortByHandler);

  class stickyFilterModal extends HTMLElement {
    constructor() {
      super();
      this.mainButton = document.getElementById(`mobile-facets`);
      window.addEventListener('scroll', this.update.bind(this));
      this.querySelector('button').addEventListener('click', this.click.bind(this), false);
      this.update();
    }
    click(e) {
      e.preventDefault();
      document.body.setAttribute('data-top', window.pageYOffset);
      document.body.style.top = `-${window.pageYOffset}px`;
      document.body.classList.add(`fixed-position`);
      document.body.classList.add('overflow-hidden-tablet');
      this.mainButton.querySelector('[tabindex]').setAttribute('tabindex', '');
      this.mainButton.classList.add('menu-opening');
      this.mainButton.setAttribute('open', 'true');
    }
    update() {
      if (window.innerWidth > 992) return;
      const rangeToShowModal = this.getTop(this.mainButton) + this.mainButton.clientHeight;
      if (window.scrollY >= rangeToShowModal && !this.classList.contains('show-modal')) {
        this.classList.add('show-modal');
      }
      if (window.scrollY < rangeToShowModal && this.classList.contains('show-modal')) {
        if (document.body.classList.contains('fixed-position')) return;
        this.classList.remove('show-modal');
      }
    }
    getTop(el) {
      return el.offsetTop + (el.offsetParent && this.getTop(el.offsetParent));
    }
  }
  customElements.define('sticky-filter-modal', stickyFilterModal);

  } catch(e) { console.error(e); }
})();
      })();
